import { CREATE_SUBJECT, CREATING_SUBJECT, DELETE_SUBJECT, DELETING_SUBJECT, GET_SUBJECTS, GETTING_SUBJECTS, SUBJECTS_ERROR, UPDATE_SUBJECT, UPDATING_SUBJECT } from "../types"

const initialState = {
    subjects: [],
    loadingSubjects: true,
    subjectsError: null,
    creatingSubject: false,
    createdSubject: null,
    updatingSubject: false,
    updatedSubject: null,
    deletingSubject: false,
    deletedSubject: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case CREATING_SUBJECT:
        return {
            ...state,
            creatingSubject :action.payload,
        }
        case CREATE_SUBJECT:
        return{
            ...state,
            creatingSubject:false,
            subjectsError:  null,
            createdSubject: action.payload,
        }
        case UPDATING_SUBJECT:
        return {
            ...state,
            updatingSubject :action.payload,
        }
        case UPDATE_SUBJECT:
        return{
            ...state,
            updatingSubject:false,
            subjectsError:  null,
            updatedSubject: action.payload,
        }
        case DELETING_SUBJECT:
        return {
            ...state,
            deletingSubject :action.payload,
        }
        case DELETE_SUBJECT:
        return{
            ...state,
            deletingSubject:false,
            subjectsError:  null,
            deletedSubject: action.payload,
        }
        case GETTING_SUBJECTS:
        return {
            ...state,
            loadingSubjects :action.payload,
        }
        case GET_SUBJECTS:
        return{
            ...state,
            loadingSubjects:false,
            subjectsError:  null,
            subjects: action.payload,
        }
        case SUBJECTS_ERROR:
        return{
            ...state,
            loadingSubjects:false,
            creatingSubject: false,
            updatingSubject: false,
            subjectsError: action.payload 
        }
        default: return state
    }

}